<template>
  <div :class="[
    'tw-h-min-[25px] tw-pl-4 tw-py-0.5 tw-pr-2 tw-rounded-l',
    props.amount > 0 && 'card_debit',
    props.amount < 0 && 'card_credit',
  ]">
    {{ new Intl.NumberFormat().format(Math.abs(amount)) }} ریال
  </div>
</template>

<script setup>

import { defineProps } from "vue";

const props = defineProps({
  amount: { type: Number, required: true },
})


</script>


<style scoped>
.card_credit {
  background: linear-gradient(270deg, rgba(31, 179, 86, 0) 0%, rgba(31, 179, 86, 0.25) 74.5%, rgba(31, 179, 86, 0.75) 100%);
}
.card_debit {
  background: linear-gradient(270deg, rgba(255, 100, 91, 0) 0%, rgba(255, 100, 91, 0.25) 74.5%, rgba(255, 100, 91, 0.75) 100%);
}
</style>
